var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8V8.6C10.5 9.44008 10.5 9.86012 10.3365 10.181C10.1927 10.4632 9.96323 10.6927 9.68099 10.8365C9.36012 11 8.94008 11 8.1 11H3.9C3.05992 11 2.63988 11 2.31901 10.8365C2.03677 10.6927 1.8073 10.4632 1.66349 10.181C1.5 9.86012 1.5 9.44008 1.5 8.6V8M8.5 5.5L6 8M6 8L3.5 5.5M6 8V2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload01);
export default __webpack_public_path__ + "static/media/download-01.f931535b52e9d97baa070594b7d4c6bb.svg";
export { ForwardRef as ReactComponent };